import React, { useState, useEffect } from "react";
import cx from "classnames";
import { useTranslation } from "react-i18next";
import { ReactComponent as IconInfoCircle } from 'bootstrap-icons/icons/info-circle.svg'

import Phone from "../../../Components/Phone/Phone";

function Phones(props) {
  const { t } = useTranslation();
  const [state, setState] = useState([]);

  const slice = (index1) => {
    const newState = state.filter((item, index2) => index1 !== index2);
    setState([...newState]);
    props.onChange(JSON.clone([...newState]));
  };

  const add = () => {
    // Bug real (auditoría 2026-08-16): no llamaba a props.onChange, a
    // diferencia de slice/onChange (que sí lo hacen tras el setState) y del
    // add() ya arreglado en el sibling Emails.js. Una fila nueva quedaba
    // invisible para el padre — los llamadores (Consumers/Form/Form.js,
    // Resources/Form/Profile/Profile.js) calculan "cambios sin guardar"
    // diffeando el payload recibido por onChange contra el original, así que
    // agregar un teléfono y navegar afuera antes de tipear en la fila nueva
    // perdía esa fila en silencio, sin warning de cambios sin guardar.
    const array = JSON.clone([...state, { ...props.options }]);
    setState(array);
    props.onChange(array);
  };

  const onChange = (index) => (phone) => {
    state[index] = phone;
    const array = JSON.clone([...state]);
    setState(array);
    props.onChange(array);
  };

  useEffect(() => {
    setState([...props.value]);
  }, [props.value]);

  return (
    <React.Fragment>
      <div className="mb-3">
        {/* sectionLabel: variante del handoff de Figma — rotulo en
            micro-etiqueta y "+" fino al extremo derecho. Ver Emails.js. */}
        <div
          className={cx(
            props.sectionLabel
              ? "form-section-label form-section-label--with-action"
              : "d-flex align-items-center form-label"
          )}
        >
          <label htmlFor="phones">
            {t("phone_plural", { context: props.context })}
          </label>
          {!props.disabled && (
            <button
              onClick={add}
              type="button"
              className={cx("btn btn-link p-0", {
                "ms-2": !props.sectionLabel,
                "form-section-label__action": props.sectionLabel,
              })}
              aria-label={t("phone_add", { context: props.context, defaultValue: "Agregar teléfono" })}
            >
              {props.sectionLabel ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  aria-hidden="true"
                >
                  <path d="M8 3.25v9.5M3.25 8h9.5" />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-plus-square-fill"
                  viewBox="0 0 16 16"
                  aria-hidden="true"
                >
                  <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0z" />
                </svg>
              )}
            </button>
          )}
        </div>
        {state.map((phone, index) => (
          <div
            className={cx("position-relative", {
              "mb-1": index !== state.length - 1,
            })}
            key={`phone${index}`}
          >
            {/* onAdd condicional: el handoff no tiene el boton "nuevo" al pie
                del input — para agregar esta el "+" del rotulo. Sin onAdd,
                Phone no lo renderiza. Se apaga solo en la variante del handoff
                porque las demas pantallas lo siguen usando. */}
            <Phone
              name="phone"
              id={`phone${index}`}
              disabled={!!props.disabled}
              value={phone}
              required={props.required}
              onChange={onChange(index)}
              hint={index + 1 === state.length}
              onAdd={props.sectionLabel ? undefined : add}
            />
            
            <div className="form-control-actions d-flex align-items-center gap-1">
              {phone.source && phone.source !== "drapp" &&
                <div>
                  <IconInfoCircle
                    width="14"
                    height="14"
                    data-tooltip-id="app-tooltip"
                    data-tooltip-html={`
                      <div>
                        ${t("entered_by_patient" ,{context: props.context, defaultValue: "Ingresado por paciente"})}
                      </div>`
                    }
                  />
                </div>
              }
              {!props.disabled && (
                // Fix responsive (2026-08-14): mismo hit-target chico que
                // Emails.js — py-0 px-1 sobre un ícono de 1em.
                <button
                  className="btn btn-sm text-danger py-2 px-2"
                  type="button"
                  onClick={() => slice(index)}
                >
                  <svg
                    width="1em"
                    height="1em"
                    viewBox="0 0 16 16"
                    className="bi bi-x"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M11.854 4.146a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708-.708l7-7a.5.5 0 0 1 .708 0z"
                    />
                    <path
                      fillRule="evenodd"
                      d="M4.146 4.146a.5.5 0 0 0 0 .708l7 7a.5.5 0 0 0 .708-.708l-7-7a.5.5 0 0 0-.708 0z"
                    />
                  </svg>
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </React.Fragment>
  );
}
export default Phones;
